// Animates the hero stat numbers (300+, 7, 19) counting up from 0 to their
// final value the first time each one scrolls into view.
const DURATION_MS = 2600;

export function initCountUp() {
  const items = document.querySelectorAll('[data-count-to]');
  if (!items.length) return;

  const observer = new IntersectionObserver((entries, obs) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      animate(entry.target);
      obs.unobserve(entry.target);
    }
  }, { threshold: 0.6 });

  items.forEach((item) => observer.observe(item));
}

function animate(el) {
  const target = parseInt(el.dataset.countTo, 10);
  const suffix = el.dataset.countSuffix ?? '';
  const start = performance.now();

  function tick(now) {
    const progress = Math.min((now - start) / DURATION_MS, 1);
    const eased = 1 - (1 - progress) ** 3;
    el.textContent = Math.round(target * eased) + suffix;
    if (progress < 1) requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);
}
